import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[480px] md:h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20epic%20scene%20handsome%20male%20protagonist%20standing%20on%20rooftop%20overlooking%20futuristic%20city%20at%20sunset%20dramatic%20cinematic%20lighting%20warm%20golden%20orange%20tones%20atmospheric%20dust%20particles%20flowing%20cape%20heroic%20pose%20manhwa%20art%20style%20clean%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫之家 - 免费韩国漫画在线阅读平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            免费韩漫 · 下拉式阅读 · 高清体验
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 max-w-xl mx-auto leading-relaxed">
            韩漫之家为您呈现海量免费韩漫资源，下拉式在线阅读，高清画质，让每一页漫画都栩栩如生
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50 hover:text-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-10 md:mt-14 grid grid-cols-3 gap-4 max-w-lg mx-auto">
            {[
              { value: '10万+', label: '漫画资源' },
              { value: '每日300+', label: '持续更新' },
              { value: '1000万+', label: '读者信赖' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}